import { Button, ButtonCallNotes, ButtonGoBack } from '../../Shared';

export const Email2 = ({
  formObjContact,
  handleFinishCall,
  handleOpen3,
  formCallNotes,
  resetPitchState,
  isDialOutcomesLoading,
}) => {
  const handleSendEmail = () => {
    const emailAddress = formObjContact?.email;
    const mailtoLink = `mailto:${emailAddress}`;
    window.location.href = mailtoLink;
  };

  return (
    <>
      <div className="h-[386px] overflow-y-auto overflow-x-hidden rounded-[20px] bg-white/30 p-6 [&::-webkit-scrollbar-thumb]:bg-secondary/80 [&::-webkit-scrollbar-track]:bg-secondary/20 [&::-webkit-scrollbar]:w-2">
        <p className="text-brand-900 font-semibold text-[18px]/[24px] text-center">
          Does the information below look correct?
        </p>
        <div className="space-y-4 mt-6">
          <div className="flex flex-col">
            <span className="font-medium text-gray-500 text-sm">
              Contact Name
            </span>
            <span className="text-xl font-medium border-b-secondary/20 border-b-2 pb-2">
              {formObjContact?.contact}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="font-medium text-gray-500 text-sm">Email</span>
            <span className="text-xl font-medium border-b-secondary/20 border-b-2 pb-2">
              {formObjContact?.email}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between rounded-[20px] bg-white/30 px-6 py-5">
        <ButtonGoBack
          onClick={() => {
            resetPitchState(true);
          }}
          disabled={isDialOutcomesLoading}
        />
        <Button
          title="Finish"
          onClick={() => {
            handleSendEmail();
            handleFinishCall();
          }}
          disabled={isDialOutcomesLoading}
        />
        <ButtonCallNotes
          onClick={handleOpen3}
          hasBg={formCallNotes && formCallNotes !== 'null'}
          disabled={isDialOutcomesLoading}
        />
      </div>
    </>
  );
};
